/* MONSAC theme — global.js */
(function () {
  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-burger]');
    if (burger) {
      var nav = document.querySelector('[data-mnav]');
      if (nav) nav.classList.toggle('open');
    }
  });

  // Product gallery: click thumb -> swap main image
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var main = document.querySelector('[data-main-img]');
      if (main) main.src = thumb.getAttribute('data-full') || thumb.src;
    }
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += (btn.getAttribute('data-qty') === 'plus') ? 1 : -1;
    if (val < 1) val = 1;
    input.value = val;
  });

  // Update cart count from /cart.js
  function refreshCartCount() {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = c.item_count;
            el.style.display = c.item_count > 0 ? 'flex' : 'none';
          });
        }).catch(function () {});
    } catch (e) {}
  }
  refreshCartCount();
})();
